module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-10.ae7659be.png";